import v from "@/lib/validator";
import { TFunction } from "i18next";

const RegisterProductSchema = (translate: TFunction) => {
    const requiredValidation = v.methods().required({message: translate('productsForm.inputs.errorsMessages.required')})
  return v.object({
    nomeProduto: requiredValidation
  });
};

export default RegisterProductSchema;
